import { useAppDispatch, useAppSelector } from "Hook/hooks";
import React, { useEffect } from "react";
import { fetchStoreSubscriptionNotice } from "../../Redux/Ducks/settingSlice";

const PosSubscriptionNotice = () => {
  const dispatch = useAppDispatch();
  const { subscription_notice } = useAppSelector((state) => state.Setting);
  const selected_store = useAppSelector(
    (state) => state.Home.selected_store,
  ) as any;

  useEffect(() => {
    if (selected_store) {
      dispatch(fetchStoreSubscriptionNotice({ store_id: selected_store }));
    }
  }, [selected_store, dispatch]);

  // 👇 Hide when data, notice, or message is missing
  if (!subscription_notice?.notice || !subscription_notice?.message) {
    return null;
  }

  const days = Number(subscription_notice?.days_remaining) || 0;

  // 16+ days → danger (red),  15 and below → warning (amber)
  const isDanger = days >= 16;

  const theme = isDanger
    ? {
        bg: "#FDECEA",
        border: "#F5C2C0",
        text: "#B3261E",
        accent: "#E5484D",
      }
    : {
        bg: "#FFF4E5",
        border: "#FFD8A8",
        text: "#8A4B08",
        accent: "#F08C00",
      };

  return (
    <div
      className={`pos-notice-bar ${isDanger ? "pos-notice-danger" : "pos-notice-warning"}`}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        padding: "10px 16px",
        background: `linear-gradient(90deg, ${theme.bg} 0%, #FFFFFF 100%)`,
        borderBottom: `1px solid ${theme.border}`,
        borderLeft: `4px solid ${theme.accent}`,
        color: theme.text,
        fontSize: 13.5,
        fontWeight: 500,
        lineHeight: 1.4,
      }}
    >
      <i
        className={`bi ${
          isDanger
            ? "bi-exclamation-octagon-fill"
            : "bi-exclamation-triangle-fill"
        }`}
        style={{ color: theme.accent, fontSize: 16, flexShrink: 0 }}
      />

      {/* 👇 API short message, untouched */}
      <span style={{ flex: 1 }}>{subscription_notice.message}</span>

      {subscription_notice?.due_date && (
        <span
          style={{
            fontSize: 12,
            fontWeight: 600,
            color: theme.text,
            background: "#FFFFFF",
            border: `1px solid ${theme.border}`,
            borderRadius: 999,
            padding: "3px 10px",
            whiteSpace: "nowrap",
          }}
        >
          Due: {subscription_notice.due_date}
        </span>
      )}
    </div>
  );
};

export default PosSubscriptionNotice;
